"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../skybase-core/notifications/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationShape = _propTypes.default.shape({
  className: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  time: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.number]),
  severity: _propTypes.default.oneOf([_constants.ALERT_TYPE_ERROR, _constants.ALERT_TYPE_WARNING, _constants.ALERT_TYPE_INFO]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object // formatMessage translation object
  ]),
  titleParams: _propTypes.default.object,
  // object with any params to be placed to translation as constant
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object // formatMessage translation object
  ]),
  messageParams: _propTypes.default.object,
  // object with any params to be placed to translation as constant
  notificationParams: _propTypes.default.shape({
    closeButton: _propTypes.default.bool
  })
});

exports.notificationShape = notificationShape;
//# sourceMappingURL=shapes.js.map